<div style="width: 100%; height: 100%" #mapWrapper>
  <google-map height="100%" width="100%" [options]="mapOptions" (mapInitialized)="mapInit($event)" *ngIf="_options"></google-map>
</div>

<div id="{{ 'map-buttons-' + id }}" class="map-btns flex flex-column align-items-start justify-content-start gap-2">
  <ion-fab  vertical="top" horizontal="end" slot="fixed">
    <ion-fab-button 
    color="light" 
    size="small" 
      *ngIf="!_options || _options.geometryAddMode !== 'DISABLED'"
    (click)="toggleShowRoads()"
    >
      <span class="material-symbols-outlined">map</span>
    </ion-fab-button>

    <ion-fab-button
      color="light"
      size="small"
      class="small map-button visible"
      id="{{ 'geometry-add-start-' + id }}"
      *ngIf="!_options || _options.geometryAddMode !== 'DISABLED'"
      (click)="startGeometryAdd(true)"
    >
      <span class="material-symbols-outlined">new_window</span>
    </ion-fab-button>

    <ion-fab-button
      color="light"
      size="small"
      id="{{ 'geometry-edit-start-' + id }}"
      class="small map-button"
      (click)="startCurrentGeometryEdit()"
    >
      <span class="material-symbols-outlined">edit_square</span>
    </ion-fab-button>

    <ion-fab-button
      color="light"
      size="small"
      id="{{ 'geometry-edit-add-sub-geometry-' + id }}"
      class="small map-button"
      (click)="addSubGeometry()"
    >
      <span class="material-symbols-outlined">timeline</span>
    </ion-fab-button>

    <ion-fab-button color="light" size="small" id="{{ 'geometry-edit-add-poi-' + id }}" class="small map-button" (click)="addPOI()">
      <span class="material-symbols-outlined">add_location_alt</span>
    </ion-fab-button>

    <ion-fab-button
      color="light"
      size="small"
      id="{{ 'geometry-edit-finish-' + id }}"
      class="small map-button"
      (click)="finishGeometryEdit()"
    >
      <span class="material-symbols-outlined">check</span>
    </ion-fab-button>

    <ion-fab-button color="light" size="small" id="{{ 'geometry-edit-cancel-' + id }}" class="small map-button" (click)="cancelButton()">
      <span class="material-symbols-outlined">close</span>
    </ion-fab-button>
  </ion-fab>
</div>
